import { User } from "./user.model";
import { ValidationTypes } from "./meta-data.model";

export class GradingInput {
  metaDataMappingId: number;
  spreadsheetId: string;
  dataGroupName: string;
  columnId: string;
  columnName: string;
  gradingInputType: string;
  etdrsGroup: string;
  etdrsNumber: number;
  gradingDropdownId: number;
  gradingDropdownOptions: GradingDropdownOption[]; // attached from sequelize
  gradingHousekeeping: boolean;
  gradingRequired: boolean;
  gradingHide: boolean;
  values: { [eye: string]: any };
  autofillLookup: number;
  etdrsMappings: {
    metaDataMappingId: number;
    etdrsNumber: number;
    values: { [eye: string]: any };
  }[];
  validationType: ValidationTypes;
  allowedValues: string; // comma separated string
}

export class GradingDropdownOption {
  spreadsheetId: string;
  columnId: string;
  fieldValue: number;
  display: string;
  autofill: boolean;
  autofillValue: number;
  autofillLookup: number;
  autofillValue2: number;
  autofillLookup2: number;
  autofillValue3: number;
  autofillLookup3: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export enum GradingInputTypes {
  textarea = "textarea",
  text = "text",
  date = "date",
  dropdown = "dropdown",
  checkbox = "checkbox",
  etdrs = "etdrs",
  eye = "eye",
  blank = "blank",
}

export class GradingHeaderInfo {
  patientId: string;
  visitId: string;
  studyId: string;
  imageComment: string;
  packageUploadComment: string;
  approvalComment: string;
  overrideComment: string;
  diagnosisComment: string;
  imageList: Array<{ imageId: number; imageInfo: string }>;
}

export class GradingStagingData {
  gradingStagingDataId?: number;
  metaDataMappingId: number;
  gradingStagingSheetId?: number;
  visit: string;
  eye: string;
  value: string;
}

export class GradingStagingSheet {
  gradingStagingSheetId?: number;
  patientId: string;
  spreadsheetId: string;
  visit: string;
  status: string;
  lockedUserId: number;
}

export class GradingSheet {
  title: string;
  spreadsheetId: string;
  inputs: GradingInput[];
  status: string;
  lockedByUser?: User;
  isExpanded? = false;
  isLocked: boolean;
  lockedBy: string;
  hasHousekeeping?: boolean;
  sortOrder?: number;
}

export enum GradingStagingSheetStatus {
  pending = "pending",
  inProgress = "in Progress",
  complete = "complete",
  escalatedSrGrader = "escalated Sr Grader",
  escalatedClinicianReview = "escalated Clinician Review",
  incomplete = "incomplete",
}



// WEBPACK FOOTER //
// ./src/app/models/grading.model.ts